module.exports = function() {
  return new Worker(__webpack_public_path__ + "daa46891616fda078060.worker.js");
};